// extracted by mini-css-extract-plugin
export default {"auto-load-more":"Home_auto-load-more__Sj3cy"};